import type { DbHighlight } from '../lib/supabase'

interface Props {
  highlights: DbHighlight[]
  onHighlightClick: (highlight: DbHighlight) => void
  onExport: () => void
  onClose: () => void
}

export function HighlightsSidebar({
  highlights,
  onHighlightClick,
  onExport,
  onClose,
}: Props) {
  const handleExport = async () => {
    onExport()
  }

  return (
    <>
      <div className="highlights-sidebar-backdrop" onClick={onClose} />
      <aside className="highlights-sidebar">
        <div className="sidebar-header">
          <h3>Highlights ({highlights.length})</h3>
          <div className="header-actions">
            {highlights.length > 0 && (
              <button
                className="export-btn"
                onClick={handleExport}
                title="Copy as Markdown"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                </svg>
                Export
              </button>
            )}
            <button className="close-btn" onClick={onClose}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>
        </div>

        {highlights.length === 0 ? (
          <div className="empty-state">
            <svg
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
            >
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
            </svg>
            <p>No highlights yet</p>
            <p className="hint">Select text while reading to highlight</p>
          </div>
        ) : (
          <ul className="highlights-list">
            {highlights.map((h) => (
              <li
                key={h.id}
                className="highlight-item"
                onClick={() => onHighlightClick(h)}
                style={{ borderLeftColor: h.color }}
              >
                <q className="highlight-text">{h.text_content}</q>
                {h.note && <p className="highlight-note">{h.note}</p>}
                <time className="highlight-time">
                  {new Date(h.created_at).toLocaleDateString()}
                </time>
              </li>
            ))}
          </ul>
        )}
      </aside>
    </>
  )
}
